// /******************************************************************
// *******************************************************************
//
// 	ORIGO: JAVASCRIPT
//
// 	AUTHOR: Colluco
//
// *******************************************************************
// ******************************************************************/
//
//
// jQuery(document).ready(function($) {
//
// 	/**************************************************************
// 		HEADER - HAMBURGER
// 	**************************************************************/
//
// 	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
//
// 	var hamburgers = document.querySelectorAll(".hamburger");
// 	if (hamburgers.length > 0) {
// 		forEach(hamburgers, function(hamburger) {
// 			hamburger.addEventListener("click", function() {
// 				this.classList.toggle("is-active");
// 				$('.mobile-nav').toggleClass('is-active');
// 				$('body').toggleClass('open--nav');
// 			}, false);
// 		});
// 	}
//
//
// 	/**************************************************************
// 		HEADER - SHRINK ON SCROLL
// 	**************************************************************/
//
// 	var root = document.documentElement;
// 	var headerTopHeight = getComputedStyle(root).getPropertyValue('--elem-header-height-lg-top').trim().slice(0, -2);
//
// 	$(window).scroll(function() {
// 	    if ($(this).scrollTop() > headerTopHeight){
// 			$('.header').addClass("shrink");
// 			$('body').addClass("header-shrunk");
// 	    } else {
// 	        $('.header').removeClass("shrink");
// 			$('body').removeClass("header-shrunk");
// 	    }
// 	});
//
//
// 	/**************************************************************
// 		MOBILE NAV - DROPDOWN FUNCTIONALITY
// 	**************************************************************/
//
// 	$( ".mobile-nav__menu__content__nav > .menu-item-has-children > a" ).append( "<span><i class='fa-solid fa-caret-down'></i></span>");
//
// 	$( ".mobile-nav__menu__content__nav > .menu-item-has-children > a > span" ).on( "click", function(e) {
// 		e.preventDefault();
//
// 		if ($(this).parent().parent().hasClass('open')) {
// 			$(this).parent().parent().removeClass('open');
// 		} else {
// 			$(".mobile-nav__menu__content__nav > .menu-item-has-children").removeClass('open');
// 			$(this).parent().parent().addClass('open');
// 		}
// 	});
//
//
// 	/**************************************************************
// 		SITE - PRETTY SELECTS
// 	**************************************************************/
//
// 	$('select:not(.forminator-select--field)').each(function(){
// 	    var $this = $(this), numberOfOptions = $(this).children('option').length;
//
// 			if ( $this.hasClass( 'sf-input-select' ) ) {
// 				// Don't do anything with S&F inputs
// 				return;
// 			}
//
// 	    $this.addClass('select-hidden');
// 	    $this.wrap('<div class="select"></div>');
// 	    $this.after('<div class="select-styled"></div>');
//
// 	    var $styledSelect = $this.next('div.select-styled');
// 	    $styledSelect.text($this.children('option').eq(0).text());
//
// 	    var $list = $('<ul />', {
// 	        'class': 'select-options'
// 	    }).insertAfter($styledSelect);
//
// 	    for (var i = 0; i < numberOfOptions; i++) {
// 	        $('<li />', {
// 	            text: $this.children('option').eq(i).text(),
// 	            rel: $this.children('option').eq(i).val()
// 	        }).appendTo($list);
// 	    }
//
// 	    var $listItems = $list.children('li');
//
// 	    $styledSelect.click(function(e) {
// 	        e.stopPropagation();
// 	        $('div.select-styled.active').not(this).each(function(){
// 	            $(this).removeClass('active').next('ul.select-options').hide();
// 	        });
// 	        $(this).toggleClass('active').next('ul.select-options').toggle();
// 	    });
//
// 	    $listItems.click(function(e) {
// 	        e.stopPropagation();
// 	        $styledSelect.text($(this).text()).removeClass('active');
// 			$this.val($(this).attr('rel')).trigger('change');
// 	        $list.hide();
// 	        //console.log($this.val());
// 	    });
//
// 	    $(document).click(function() {
// 	        $styledSelect.removeClass('active');
// 	        $list.hide();
// 	    });
// 	});
//
//
// 	/**************************************************************
// 		MODAL
// 	**************************************************************/
//
// 	$('.click--modal').on('click', function() {
// 		$('.modal').addClass('active');
// 		$('body').addClass('open--modal');
//
// 		var type = $(this).data('modal-type');
//
// 		if (type == 'image') {
// 			var img = $(this).data('modal-url');
// 			var alt = $(this).data('modal-alt');
//
// 			$('.modal__content').addClass(type);
//
// 			$(".modal .modal__content").html(
// 				"<img src='"+img+"' alt='"+alt+"'>"
// 			);
//
// 			$('.modal .modal__content').addClass('active');
// 			$('.modal__loader').addClass('hidden');
// 		} else if (type == 'video') {
// 			var vid = $(this).data('modal-url');
//
// 			$('.modal__content').addClass(type);
//
// 			$(".modal .modal__content").html(
// 				"<div class='video-container'><video class='video' autobuffer><source src="+vid+" type='video/mp4' /></video><div class='play-pause'><label for='play-pause__bttn'><div class='play_pause_icon play'></div></label><input type='checkbox' id='play-pause__bttn'></div></div>"
// 			);
//
// 			$('.modal .modal__content').addClass('active');
// 			$('.modal__loader').addClass('hidden');
// 		}
// 	});
//
// 	$(document).on('click', function (e) {
// 		if ($(e.target).closest(".modal__content, .click--modal").length === 0) {
// 			$('.modal').removeClass('active');
// 			$('.modal__content').removeClass('active');
// 			$('body').removeClass('open--modal');
//
// 			setTimeout(
// 				function() {
// 					$('.modal__loader').removeClass('hidden');
// 					$('.modal__content').html('').removeClass('team').removeClass('image');
// 				}, 500);
// 		}
// 	});
//
// 	$(document).on('click', '.modal__content__close, .modal-close', function() {
// 		$('.modal').removeClass('active');
// 		$('.modal__content').removeClass('active');
// 		$('body').removeClass('open--modal');
//
// 		setTimeout(
// 		  function() {
// 			$('.modal__loader').removeClass('hidden');
// 			$('.modal__content').html('').removeClass('team').removeClass('image');
// 		  }, 500);
// 	});
//
//
// 	/**************************************************************
// 		VIDEO - PLAY PAUSE
// 	**************************************************************/
//
// 	function wrapVideosAndAddButton() {
// 		// Select all video elements on the page
// 		$('video:not(.elem-video-bg)').each(function() {
// 			// Create a container div
// 			var $container = $('<div class="video-container">');
//
// 			// Define a specific HTML element to add
// 			// For example, an informational badge with custom HTML structure and classes
// 			var specificElementHTML = '<div class="play-pause"><label for="play-pause__bttn"><div class="play_pause_icon play"></div></label><input type="checkbox" id="play-pause__bttn"></div>';
// 			// Or create the element with jQuery for more complex structures
// 			var $specificElement = $(specificElementHTML);
//
// 			// Clone the video to keep event listeners if any
// 			var $videoClone = $(this).clone(true);
//
// 			// Append the cloned video and the specific element to the container
// 			$container.append($videoClone).append($specificElement);
//
// 			// Replace the original video with the container
// 			$(this).replaceWith($container);
// 		});
// 	}
//
// 	wrapVideosAndAddButton();
//
// 	$(document).on('click', '.video-container', function() {
// 		var $container = $(this);
// 		var $video = $('video', $container);
// 		var videoFile = $video.get(0);
//
// 		if(videoFile.paused) {
// 			$('.play-pause', $container).fadeOut();
// 			$('.play_pause_icon', $container).addClass('pause').removeClass('play');
// 			videoFile.play();
// 		} else {
// 			$('.play-pause', $container).fadeIn();
// 			$('.play_pause_icon', $container).addClass('play').removeClass('pause');
// 			videoFile.pause();
// 		}
// 	});
//
// 	$(document).on('mouseenter', '.video-container', function() {
// 		var $container = $(this);
// 		var $video = $('video', $container);
// 		var videoFile = $video.get(0);
//
// 		if(!videoFile.paused) {
// 			$('.play-pause', $container).fadeIn();
// 		}
// 	}).on('mouseleave', '.video-container', function() {
// 		var $container = $(this);
// 		var $video = $('video', $container);
// 		var videoFile = $video.get(0);
//
// 		if(!videoFile.paused) {
// 			$('.play-pause', $container).fadeOut();
// 		}
// 	});
//
// 	$(document).on('ended', '.video-container video', function() {
// 		var $container = $(this).closest('.video-container');
// 		$('.play-pause', $container).fadeIn();
// 		$('.play_pause_icon', $container).removeClass('pause').addClass('play');
// 	});
//
//
// 	/******************************************************************
// 		BREADCRUMBS
// 	******************************************************************/
//
// 	// Handler for clicking the ellipsis
// 	$('.breadcrumbs__ellipsis > a').on('click', function(e) {
// 		e.preventDefault(); // Prevent the default action of the link
// 		$(this).parent().find('.tooltip').toggleClass('active'); // Show or hide the tooltip
// 	});
//
// 	$(document).click(function(event) {
// 		var $tooltip = $('.tooltip.active');
// 		if ($tooltip.length && !$tooltip.is(event.target) && $tooltip.has(event.target).length === 0 && !$(event.target).closest('.breadcrumbs__ellipsis a').length) {
// 			$tooltip.removeClass('active');
// 		}
// 	});
//
//
// 	/**************************************************************
// 		ACCORDION - DESELECT RADIO
// 	**************************************************************/
//
// 	$('.element--accordion__tab input[type="radio"]').on('click', function() {
// 		var $radio = $(this);
//
// 		if ($radio.data('waschecked') === true) {
// 			$radio.prop('checked', false);
// 			$radio.data('waschecked', false);
// 		} else {
// 			$radio.data('waschecked', true);
// 		}
//
// 		$('input[name="' + $radio.attr('name') + '"]').not($radio).data('waschecked', false);
// 	});
//
//
// 	/**************************************************************
// 		READ MORE BUTTON
// 	**************************************************************/
//
// 	$('.component--read-more').each(function() {
// 		var $this = $(this);
//
// 		// Check if the text is taller than the height of 3 lines
// 		if ($this.outerHeight() > parseInt($this.css('line-height')) * 5) {
// 			$this.addClass('closed');
// 			$this.append('<a href="#" class="component--read-more__link link">Read More</a>');  // Add "Read More" link
// 		}
//
// 		// Reattach click event to toggle expansion
// 		$('.component--read-more__link').click(function(e) {
// 			e.preventDefault();
// 			var $parent = $(this).parent();
//
// 			if ($parent.hasClass('open')) {
// 				$parent.removeClass('open').addClass('closed');
// 				$(this).text('Read More');
// 			} else {
// 				$parent.removeClass('closed').addClass('open');
// 				$(this).text('Read Less');
// 			}
// 		});
// 	});
//
//
// 	/**************************************************************
// 		IMAGE - BEFORE / AFTER SLIDER
// 	**************************************************************/
//
// 	document.querySelectorAll('.element--image-comparison').forEach(function(element) {
// 		const slider = element.querySelector('.element--image-comparison__slider');
// 		const imgAfter = element.querySelector('.element--image-comparison__img--after');
//
// 		function moveSlider(event) {
// 			const clientX = event.touches ? event.touches[0].clientX : event.clientX;
// 			const shiftX = event.touches ? event.touches[0].clientX - slider.getBoundingClientRect().left : event.clientX - slider.getBoundingClientRect().left;
//
// 			document.onmousemove = document.ontouchmove = function(event) {
// 				let newClientX = event.touches ? event.touches[0].clientX : event.clientX;
// 				let newLeft = newClientX - shiftX - element.getBoundingClientRect().left;
//
// 				const rightEdge = element.offsetWidth - slider.offsetWidth;
// 				if (newLeft < 0) {
// 					newLeft = 0;
// 				}
// 				if (newLeft > rightEdge) {
// 					newLeft = rightEdge;
// 				}
//
// 				slider.style.left = (newLeft + 25) + 'px';
// 				imgAfter.style.clipPath = `polygon(0 0, ${(newLeft + slider.offsetWidth / 2) / element.offsetWidth * 100}% 0, ${(newLeft + slider.offsetWidth / 2) / element.offsetWidth * 100}% 100%, 0% 100%)`;
// 			};
//
// 			document.onmouseup = document.ontouchend = function() {
// 				document.onmousemove = document.ontouchmove = null;
// 				document.onmouseup = document.ontouchend = null;
// 			};
// 		}
//
// 		slider.onmousedown = function(event) {
// 			event.preventDefault();
// 			moveSlider(event);
// 		};
//
// 		slider.ontouchstart = function(event) {
// 			event.preventDefault();
// 			moveSlider(event);
// 		};
//
// 		slider.ondragstart = function() {
// 			return false;
// 		};
// 	});
//
//
// 	/**************************************************************
// 		ANIMATED TITLE - RESIZE
// 	**************************************************************/
//
// 	const svgs = document.querySelectorAll('.component--ani-svg-txt > svg');
//
// 	svgs.forEach(svg => {
// 		const text = svg.querySelector('text');
//
// 		// Get the bounding box of the text
// 		const bbox = text.getBBox();
//
// 		// Set the width and height of the SVG to match the bounding box
// 		svg.setAttribute('width', bbox.width);
// 		svg.setAttribute('height', bbox.height);
//
// 		// Set the viewBox to start at (0, 0) and cover the bounding box dimensions
// 		svg.setAttribute('viewBox', `0 0 ${bbox.width} ${bbox.height}`);
//
// 		// Center the text by adjusting its x and y attributes
// 		text.setAttribute('x', bbox.width / 2);
// 		text.setAttribute('y', bbox.height / 2);
//
// 		// Adjust the text alignment properties
// 		text.setAttribute('text-anchor', 'middle');
// 		text.setAttribute('dominant-baseline', 'central');
// 	});
//
// 	// Intersection Observer to detect when the SVG is in view
// 	const observerOptions = {
// 		root: null,
// 		rootMargin: '0px',
// 		threshold: 0.1 // Trigger when 10% of the element is in view
// 	};
//
// 	const observer = new IntersectionObserver((entries, observer) => {
// 		entries.forEach(entry => {
// 			if (entry.isIntersecting) {
// 				entry.target.style.opacity = 1;
// 				entry.target.classList.add('animate-in-view');
// 				observer.unobserve(entry.target); // Stop observing once the animation starts
// 			}
// 		});
// 	}, observerOptions);
//
// 	// Start observing each SVG element after it has been resized and positioned
// 	svgs.forEach(svg => {
// 		observer.observe(svg);
// 	});
//
//
// 	/**************************************************************
// 		ANIMATE ON SCROLL
// 	**************************************************************/
//
// 	AOS.init();
//
// 	$(window).on('load', function () {
// 		AOS.refresh();
// 	});
// });
//
//
// /******************************************************************
// 	GOOGLE MAPS - INITIALISE
// ******************************************************************/
//
// async function initializeMaps() {
// 	const { Map } = await google.maps.importLibrary("maps");
// 	const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");
//
// 	const mapElements = document.querySelectorAll('.element--map > div');
//
// 	mapElements.forEach(el => {
// 		const lat = parseFloat(el.dataset.lat);
// 		const lng = parseFloat(el.dataset.lng);
// 		const zoom = parseInt(el.dataset.zoom, 10);
// 		const pin = el.dataset.pin;
// 		const ui = el.dataset.ui === 'true';
// 		const mapid = el.dataset.mapid;
// 		const mapElementId = el.id;
//
// 		const mapOptions = {
// 			center: new google.maps.LatLng(lat, lng),
// 			zoom: zoom,
// 			mapId: mapid,
// 			disableDefaultUI: ui
// 		};
//
// 		const map = new google.maps.Map(document.getElementById(mapElementId), mapOptions);
//
// 		if (pin) {
// 			const pin_img 		= document.createElement("img");
// 				  pin_img.src	= pin;
//
// 			const marker = new google.maps.marker.AdvancedMarkerElement({
// 				map,
// 				position: new google.maps.LatLng(lat, lng),
// 				content: pin_img
// 			});
// 		} else {
// 			const marker = new google.maps.marker.AdvancedMarkerElement({
// 				map,
// 				position: new google.maps.LatLng(lat, lng)
// 			});
// 		}
// 	});
// }
//
jQuery( function( $ ) {

    /**
     * Sticky Header
     */
    const stickyHeaderScrollWatcher = () => {
        const headerBlock = $('.wp-site-blocks > header.wp-block-template-part');

        if ($(window).scrollTop() > 300) {
            headerBlock.addClass('is-pinned');
        } else {
            headerBlock.removeClass('is-pinned');
        }
    };

    $(window).on('scroll', stickyHeaderScrollWatcher);

});

jQuery(document).ready(function($) {

  // Term headers: click the header to toggle its next panel
  $(document).on('click', '.services .services__group-header.has-children', function(e) {
    // allow any links inside term header if you ever add them
    if ($(e.target).closest('a').length) return;

    const $header = $(this);
    const $panel  = $header.next('.services__panel');
    if (!$panel.length) return;

    $header.toggleClass('is-open');
    $panel.stop(true, true).slideToggle(200);
  });

  // Post headers: only the explicit toggle button opens/closes; title link navigates
  $(document).on('click', '.services .services__post-header.has-children .services__toggle', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $header = $(this).closest('.services__post-header');
    const $panel  = $header.next('.services__panel');
    if (!$panel.length) return;

    $header.toggleClass('is-open');
    $panel.stop(true, true).slideToggle(200);
  });

});